import React from "react";
import { Box } from "@mui/material";
import GraphicalChart from "src/components/pages/dashboard/GraphicalChart";
import ChatStatics from "src/components/pages/dashboard/ChatStatics";
import useStyles from "./Styles";

const ThirdLayer = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.rootContainer}>
      <Box className={classes.flexItem1}>
        <GraphicalChart />
      </Box>
      <Box className={classes.flexItem2}>
        <ChatStatics />
      </Box>
    </Box>
  );
};

export default ThirdLayer;
